import { useEffect } from "react";

export const usePreventScroll = (isDisabled?: boolean) => {
  const paddingRight = window.innerWidth - document.documentElement.clientWidth;

  useEffect(() => {
    if (isDisabled) {
      return;
    }

    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = `${paddingRight}px`;
    document.documentElement.style.touchAction = "none";

    return () => {
      document.documentElement.style.removeProperty("overflow");
      document.documentElement.style.removeProperty("padding-right");
      document.documentElement.style.removeProperty("touch-action");
    };
  }, [isDisabled]);
};
